import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {FxRateCurrencyType, FxRateRateType} from '../../constants/fx-rate-constants';
import {getCurrenciesTreeData, getReport} from '../../store/selectors/fx-rate.selectors';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {FxRateState} from '../../store/reducers/fx-rate.reducer';
import {select, Store} from '@ngrx/store';
import {TreeItemNode} from '@shared/models/tree-selector.models';
import {BehaviorSubject, Observable} from 'rxjs';
import {UpdateReportCommand, AddFxRateReportDynamicFieldsCommand} from '../../commands/fx-rate-report.command';
import {CommandService} from '@core/services/command.service';
import {take} from 'rxjs/operators';
import {combineLatest, of} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {TimeZoneService} from '@core/services/time-zone.service';
import {ClearFxRateReportAction, GetFxRateReportAction} from '../../store/actions/fx-rate.action';
import {FieldSection} from '@shared/models/field-section';
import {FxRateReportModel} from '../../models/fx-rate-report.model';
import {
    getVirtualGridFieldSections
} from '@shared/store/selectors/virtual-grid.selector';
import {Configuration} from '@shared/models/configuration';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {SnackBarService} from '@core/services/snack-bar.service';
import {ReportSettingsFormComponent} from '../report-settings-form/report-settings-form.component';
import {SetActivityFeedAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";

@Component({
    standalone: false,
    selector: 'particle-add-fx-rate-report',
    templateUrl: './add-fx-rate-report.component.html',
    styleUrls: ['./add-fx-rate-report.component.scss']
})
export class AddFxRateReportComponent implements OnInit, OnDestroy {

    @ViewChild('reportSettings') reportSettingsFormComponent: ReportSettingsFormComponent;

    breadcrumbs: BreadcrumbModel[];
    reportingCurrencySelectorTitle = 'Reporting Currencies';
    translationCurrencySelectorTitle = 'Translation Currencies';
    reportId: string;
    reportName: string;
    showSettings = false;
    rateType: string;
    summaryRateView: string;
    detailRateView: string;
    currencyType = FxRateCurrencyType;
    reportingCurrencyCodes: string[];
    invalidateSubject: InvalidateSubject;
    reportingCurrencyNames: any = {};
    translationCurrencyCodes: string[];
    translationCurrencyNames: any = {};
    addOrEdit: string;
    fieldSections$: Observable<FieldSection[]>;
    reportModel$: Observable<FxRateReportModel>;
    reportModel: FxRateReportModel = null;
    sourceType = 'FxRateReportDetails';
    inputForm: any;
    cancelDisabled: boolean = true;
    disableRateFormatSelection = false;
    disable$ = new BehaviorSubject(true);

    constructor(private store: Store<FxRateState>,
                private fuseSplashScreenService: FuseSplashScreenService,
                private commandService: CommandService,
                private router: Router,
                private timeZoneService: TimeZoneService,
                private route: ActivatedRoute,
                private fxratestore: Store<FxRateState>,
                private platformSidebarStore: Store<PlatformSidebarState>,
                private snackBarService: SnackBarService) {
        this.route.params.subscribe(params => {
            if (params['reportID']) {
                this.reportId = params['reportID'];
                this.fxratestore.dispatch(new GetFxRateReportAction(this.reportId));
            }
        });
        this.invalidateSubject = new InvalidateSubject();

        this.fxratestore.dispatch(new GetFxRateReportAction(this.reportId));
        this.fieldSections$ = this.store.pipe(select(getVirtualGridFieldSections, this.sourceType));
        this.reportModel$ = this.fxratestore.select(getReport(this.reportId));
        const combinedData$ = combineLatest([this.fieldSections$, this.reportModel$]);
        let hasData = false;
        combinedData$.subscribe((result: any[]) => {
            if (!hasData && result[1]) {
                hasData = true;
                this.reportModel = result[1];
                this.showSettings = true;
                this.reportName = this.reportModel.reportName;
                this.rateType = this.reportModel.rateType;
                this.fixDates(this.reportModel);
              this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', 'id': `${this.reportModel.id}`, 'title': this.reportModel.reportName, isDefault: false}));
            }
        });
    }


    ngOnInit() {

        if (this.reportModel) {
            this.addOrEdit = 'Edit Report';
            this.cancelDisabled = false;
        } else {
            this.addOrEdit = 'Add Report';
            this.cancelDisabled = true;
        }
        this.breadcrumbs = [
            <BreadcrumbModel>{
                id: 'fx-rates',
                title: 'FX Rates',
                type: '',
                relativeUrl: 'itrce/fxrates'
            },
            <BreadcrumbModel>{
                id: 'add-report',
                title: this.addOrEdit,
                type: '',
                relativeUrl: 'itrce/fxrates/add-report'
            }
        ];


    }

  private fixDates(reportModel: FxRateReportModel) {
      if (!reportModel.isDateFixed) {
        for (let i = 0; i < reportModel.dates.length; i++) {
          reportModel.dates[i] = this.timeZoneService.addTimezoneOffsetToUTCDate(reportModel.dates[i]);
        }
        reportModel.isDateFixed = true;
      }
    }

    cancel() {
        this.fuseSplashScreenService.show();
        this.addDynamicFieldsCommand(this.reportName);
    }

    onFormValueChanges(event: any) {
        this.inputForm = event;
    }

    updateRateFormatVisibility(event: boolean) {
      this.disableRateFormatSelection = event;
    }

    done() {
        const combinedData$ = combineLatest([this.store.select(getCurrenciesTreeData(this.reportId, this.currencyType.Reporting)),
            this.store.select(getCurrenciesTreeData(this.reportId, this.currencyType.Translation))]);
        let hasData = false;
        combinedData$.subscribe((result: any[]) => {
            if (!hasData && result && result[0] && result[1]) {
                hasData = true;
                let data: TreeItemNode[] = result[0];
                this.reportingCurrencyCodes = [];
                data.forEach(d => {
                    if (d.item.isChecked) {
                        this.reportingCurrencyCodes = [...this.reportingCurrencyCodes, d.item.cells['title'].value];
                        this.reportingCurrencyNames[d.item.cells['title'].value] = d.item.cells['title'].displayText;
                    }
                });
                data = result[1];
                this.translationCurrencyCodes = [];
                data.forEach(d => {
                    if (d.item.isChecked) {
                        this.translationCurrencyCodes = [...this.translationCurrencyCodes, d.item.cells['title'].value];
                        this.translationCurrencyNames[d.item.cells['title'].value] = d.item.cells['title'].displayText;
                    }
                });

                // validate
                if (!this.reportingCurrencyCodes || (this.reportingCurrencyCodes && this.reportingCurrencyCodes.length === 0)) {
                    this.snackBarService.showError('Please select at least one reporting currency.');
                    return;
                }
                if (!this.translationCurrencyCodes || (this.translationCurrencyCodes && this.translationCurrencyCodes.length === 0)) {
                    this.snackBarService.showError('Please select at least one translation currency.');
                    return;
                }
                if (this.reportSettingsFormComponent.isInvalidForm()) {
                    console.log('Form is invalid, returning.');
                    return;
                }

                this.addReport();
            }
        });
    }

    onValidationChange(event: boolean) {
        this.disable$.next(!event);
    }

    addReport() {
        const command = new UpdateReportCommand();
        command.reportingCurrencyCodes = this.reportingCurrencyCodes;
        command.translationCurrencyCodes = this.translationCurrencyCodes;
        command.reportingCurrencyNames = this.reportingCurrencyNames;
        command.translationCurrencyNames = this.translationCurrencyNames;
        command.reportId = this.reportId;
        command.dates = [];
        command.rateType = this.reportModel.rateType;
        command.summaryRateView = this.inputForm.controls['summaryRateView'].value;
        command.detailRateView = this.inputForm.controls['detailsRateView'].value;
        if (command.reportingCurrencyCodes.length > 1) {
          command.fxRateFormats = ['MultiplyBy'];
        } else {
          command.fxRateFormats = this.inputForm.controls['fxRateFormats'].value ? this.inputForm.controls['fxRateFormats'].value : ['MultiplyBy'];
        }

        switch (command.rateType) {
            case FxRateRateType.TaxYearRate: {
                this.getFixedDate(this.inputForm.controls['taxYearEnd'].value);
                // const taxYearEndString = this.timeZoneService.getUTCDateWithoutTimeString(this.inputForm.controls['taxYearEnd'].value);
                const taxYearEnd = this.timeZoneService.getUTCDateWithoutTime(this.inputForm.controls['taxYearEnd'].value);
                command.dates = [taxYearEnd];
                break;
            }
            case FxRateRateType.PeriodRate: {
                // const startDateString = this.timeZoneService.getUTCDateWithoutTimeString(this.inputForm.controls['startDate'].value);
                const startDate = this.timeZoneService.getUTCDateWithoutTime(this.inputForm.controls['startDate'].value);
                // const endDateString = this.timeZoneService.getUTCDateWithoutTimeString(this.inputForm.controls['endDate'].value);
                const endDate = this.timeZoneService.getUTCDateWithoutTime(this.inputForm.controls['endDate'].value);

                if (startDate > endDate) {
                    this.snackBarService.showError(`Start Date can't be greater than End Date!`);
                    return;
                }

                command.dates = [startDate, endDate];
                break;
            }
            case FxRateRateType.SpotRate: {
                this.inputForm.controls['spotDates'].controls.forEach(o => {
                    // const dateString = this.timeZoneService.getUTCDateWithoutTimeString(o.controls['date'].value);
                    const date = this.timeZoneService.getUTCDateWithoutTime(o.controls['date'].value);
                    command.dates = [...command.dates, date];
                });
                break;
            }
        }
        if (command.dates && command.dates.length === 0) {
            this.snackBarService.showError('No date is selected.');
            return;
        }
        command.reportName = this.inputForm.controls['reportTitle'].value;
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).pipe(take(1)).subscribe(data => {
            if (data) {
                this.addDynamicFieldsCommand(command.reportName);
                this.fuseSplashScreenService.hide();
                console.log(data);
            }
        }, error => {
            this.fuseSplashScreenService.hide();
        });
    }

  private getFixedDate(date) {
    console.log('[FxRate] Inside get fixed date', typeof date, date);
    const taxYearEndString = this.timeZoneService.getUTCDateWithoutTimeString(date);
    const taxYearEndFromString = this.timeZoneService.getUTCDateWithoutTime(taxYearEndString);
    const taxYearEndFromDate = this.timeZoneService.getUTCDateWithoutTime(date);
    console.log('[FxRate] String', taxYearEndString);
    console.log('[FxRate] FromString', taxYearEndFromString);
    console.log('[FxRate] FromDate', taxYearEndFromDate);
  }

    addDynamicFieldsCommand(reportName: string) {
        const command = new AddFxRateReportDynamicFieldsCommand();
        command.reportId = this.reportId;
        command.sourceType = this.sourceType;
        command.rateView = 'SimpleAverage';
        this.commandService.executeCommand(command).pipe().subscribe(state => {
            if (state) {
                this.invalidateSubject.invalidate();
                const config = Configuration.getSmartGridConfig(this.sourceType);
                config.SourceType = state.Payload.SourceType;
                config.Parameters['REPORT_ID'] = this.reportId;
                config.Parameters['RATE_VIEW'] = 'Simple';
                Configuration.setSmartGridConfig(config.SourceType, config);
                // clear store
                this.fxratestore.dispatch(new ClearFxRateReportAction(this.reportId));
                this.fuseSplashScreenService.hide();
                // Segment-array navigation so "(" and ")" in the report name are escaped (see FxRateReportContentComponent).
                this.router.navigate(['itrce', 'fxrates', 'fx-rates-view-report', reportName, this.reportId]);
            }
        });
    }

    ngOnDestroy(): void {
    }

}
